import { Navigate, useLocation } from 'react-router-dom';
import MainLayout from './Layouts/MainLayout';
import useAuthStore from '@/src/store/useAuthStore';
import RootErrorBoundary from '@/components/organism/RootErrorBoundary';
import RootSuspense from '@/components/organism/RootSuspense';
import PATH from '@/src/routes/path';

const ProtectedPrivateRoute = () => {
  const location = useLocation();
  const { pathname } = location;
  const auth = useAuthStore(state => state.auth);
  if (!auth) {
    return <Navigate to={PATH.LOGIN} replace />;
  }
  if (pathname === '/') {
    return <Navigate to={PATH.NORMAL_CUSTOMER_LIST} replace />;
  }

  return (
    <RootErrorBoundary>
      <RootSuspense>
        <MainLayout />
      </RootSuspense>
    </RootErrorBoundary>
  );
};

export default ProtectedPrivateRoute;
